// extracted by mini-css-extract-plugin
export default {"root":"massage_root__bP9tN","caps":"massage_caps__3Hjd0","big":"massage_big__nyzNv"};